exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-49d605f0]{position:fixed;z-index:102}.faces[data-v-49d605f0]{flex-flow:column nowrap!important}.tab-content-inner[data-v-49d605f0]{width:100%;height:100%}.content-wrapper[data-v-49d605f0]{position:relative;padding-top:10px}.details[data-v-49d605f0]{text-decoration:none}", ""]);

// exports
